(function () {
  function init() {
    var els = document.querySelectorAll('.reveal:not([data-reveal-bound])');
    if (!els.length) return;

    els.forEach(function (el) {
      el.setAttribute('data-reveal-bound', '1');
      el.classList.add('js-pending');
    });

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -5% 0px' }
    );

    els.forEach(function (el) {
      io.observe(el);

      var rect = el.getBoundingClientRect();
      var nearViewport = rect.top < (window.innerHeight * 1.15);
      if (nearViewport) {
        setTimeout(function () {
          if (!el.classList.contains('in')) {
            el.classList.add('in');
          }
        }, 800);
      }
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  document.addEventListener('shopify:section:load', init);
})();
